import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import {
  CreateExternalWalletAddress,
  ErrorResponse,
  ExternalWalletAddress,
} from 'types';

import { api } from 'utils';

const useCreateExternalWalletAddress = (): UseMutationResult<
  ExternalWalletAddress,
  ErrorResponse,
  CreateExternalWalletAddress
> => {
  return useMutation((data) => api.post(url.externalWalletAddresses, data));
};

export default useCreateExternalWalletAddress;
